//import hintaAlueet from "../data/postinumerot2025.geojson";
//import hintaAlueet from "../data/postinumerot2025webmercator.geojson"
//import rajat from "../data/kuntarajat.geojson"
//import rajat from "../data/SykeRakennuksetSelitteet_Pori.json";
import React, { useState, useEffect } from "react";
//import ReactGA from "react-ga4";
import ReCAPTCHA from "react-google-recaptcha";
//import Container from "@mui/material/Container";
//import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
//import MKBox from "components/MKBox";
import kunnat from "kunnat";
import { Card, CardContent, Typography, Button } from "@mui/material";
import { MapContainer, TileLayer, Marker, Popup, useMapEvents, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import {
  EmailShareButton,
  FacebookShareButton,
  FacebookMessengerShareButton,
  ThreadsShareButton,
  InstapaperShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  InstapaperIcon,
  LinkedinIcon,
  TelegramIcon,
  ThreadsIcon,
  //TwitterIcon,
  WhatsappIcon,
  XIcon,
} from "react-share";
import {
  FIND_STRATEGYMAPS_BY_MUNICIPALITY,
  CREATE_STRATEGYMAP,
  FIND_VOTES_BY_MUNICIPALITY,
  CREATE_VOTING,
} from "queries";
import { useQuery, useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
//import bgImage from "assets/images/strategia.jpg";
/* eslint-disable react/prop-types */
const Kartta = ({ selectedKunta, setError }) => {
  //console.log(selectedKunta);
  const [t] = useTranslation("common");
  useEffect(() => {
    //tracker.trackPageView({});
    //console.log(localStorage.getItem("id"));
    let id = 0;
    if (localStorage.getItem("id") !== undefined) {
      // eslint-disable-next-line
      id = localStorage.getItem("id");
    }
    //console.log(id);
    /*ReactGA.event({
      category: "Kartta",
      action: "opened",
      label: window.location.pathname,
      value: selectedKunta,
      user: id,
    });
    */ // optional
    //value: 99, // optional, must be a number
    //nonInteraction: true, // optional, true/false
    //transport: "xhr", // optional, beacon/xhr/image
    //});
    /*ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: id,
      municipality: selectedKunta,
    });*/
  }, []);
  // eslint-disable-next-line
  const [x, setX] = useState(61.877660372);
  // eslint-disable-next-line
  const [y, setY] = useState(21.823140984);
  const [zoom, setZoom] = useState(13);
  // eslint-disable-next-line
  const [idea, setIdea] = useState("");
  //const [selected, setSelected] = useState("Kommentit");
  //const [ideas, setIdeas] = useState([]);
  // eslint-disable-next-line
  const [ideatext, setIdeatext] = useState("");
  // eslint-disable-next-line
  const [selectedIdea, setSelectedIdea] = useState(t("strategy.vision"));
  const [votes, setVotes] = useState([]);
  //const [token, setTokeni] = useState("");
  ////console.log(token);
  const [smapitems, setSmapitems] = useState([]);
  // eslint-disable-next-line
  const [token, setTokeni] = useState("");
  const [verified, setVerified] = useState(false);
  const [submitted] = useState(false);
  const [executing] = useState(false);
  //const [verified, setVerified] = useState(false);
  //const [submitted, setSubmitted] = useState(false);
  ////console.log(submitted);
  //const [executing, setExecuting] = useState(false);
  ////console.log(executing);
  ////console.log(setExecuting);
  const [createStrategymap] = useMutation(CREATE_STRATEGYMAP, {
    refetchQueries: [
      { query: FIND_STRATEGYMAPS_BY_MUNICIPALITY, variables: { municipality: selectedKunta } },
    ],
    // eslint-disable-next-line
    onError: (error) => {
      setError("virhe");
      //error.graphQLErrors[0].message
      //console.log(error);
    },
  });
  const smapitemssw = useQuery(FIND_STRATEGYMAPS_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });
  useEffect(() => {
    let selected = kunnat.filter((mun) => mun.name === selectedKunta);
    //console.log(selected);
    setX(selected[0].x);
    setY(selected[0].y);
    setZoom(13);
  }, []);
  useEffect(() => {
    let selected = kunnat.filter((mun) => mun.name === selectedKunta);
    //console.log(selected);
    setX(selected[0].x);
    setY(selected[0].y);
    //console.log(x);
    //console.log(y);
  }, [selectedKunta]);
  useEffect(() => {
    let smapitemss = [];
    //console.log(smapitemssw);
    //let municipalitiess = [];
    if (smapitemssw.data) {
      smapitemss = smapitemssw.data.findStrategymapsByMunicipality;
      //setOrgans(organss);
      //console.log(smapitemss);
      //let secs = smapitemss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setsmapitems(secs);
      setSmapitems(smapitemss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [smapitemssw]);
  const handleSubmit = () => {
    //event.preventDefault();
    const aika = Date.now();
    const pvm = new Date(aika);
    for (let i = 0; i < markers.length; i++) {
      createStrategymap({
        variables: {
          maptext: markers[i].mapitem,
          x: markers[i].lat,
          y: markers[i].lng,
          strategydatetime: pvm.toString(),
          municipality: selectedKunta,
          userid: localStorage.getItem("id"),
          active: true,
        },
      });
    }
    setMarkers([]);
    window.confirm("Kiitos kommentistasi");
    setVerified(!verified);
  };
  const handleVote = (event) => {
    //console.log(event);
    const aika = Date.now();
    const pvm = new Date(aika);
    createVoting({
      variables: {
        strategymapid: event,
        userid: localStorage.getItem("id"),
        votedatetime: pvm.toString(),
        municipality: selectedKunta,
      },
    });
  };
  const votessw = useQuery(FIND_VOTES_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });
  const [createVoting] = useMutation(CREATE_VOTING, {
    refetchQueries: [
      { query: FIND_VOTES_BY_MUNICIPALITY, variables: { municipality: selectedKunta } },
    ],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addmapitem)
    }*/
  });
  useEffect(() => {
    let votess = [];
    //console.log(votessw);
    //let municipalitiess = [];
    if (votessw.data) {
      votess = votessw.data.findVotesByMunicipality;
      //setOrgans(organss);
      //console.log(votess);
      //let secs = proposalss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setProposals(secs);
      setVotes(votess);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [votessw]);
  function voteCount(p) {
    //console.log(p);
    return votes.filter((a) => a.strategymapid === p).length;
  }
  // Fix marker icon issue
  delete L.Icon.Default.prototype._getIconUrl;
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
    iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  });
  /*function UpdateMapCentre(props) {
    const map = useMap();
    map.panTo(props.mapCentre);
    return null;
  }
  <UpdateMapCentre mapCentre={changedCoords} />  
  */
  const MapClickHandler = ({ onMapClick }) => {
    useMapEvents({
      click(e) {
        const mapitem = prompt("Anna kommentti tähän paikkaan:");
        if (mapitem) {
          onMapClick({ lat: e.latlng.lat, lng: e.latlng.lng, mapitem });
        }
      },
    });
    return null;
  };
  function onChange(value) {
    //console.log("Captcha value:", value);
    setTokeni(value);
    //console.log(token);
    setVerified(!verified);
  }
  const [markers, setMarkers] = useState([]);

  const handleMapClick = (marker) => {
    setMarkers([...markers, marker]);
  };

  const handleRemove = (event) => {
    //console.log(event);
    let newmarks = markers.filter((cont) => {
      return cont.mapitem !== event;
    });
    setMarkers(newmarks);
  };
  const shareUrl = "https://kunta.live/strategy/" + selectedKunta;
  const title = "Kunta.live";
  const divstyle = {
    backgroundColor: "white",
    borderRadius: 5,
    opacity: 0.9,
  };
  /*function MyComponent() {
    const map = useMapEvents("click", () => {
      map.setView([x, y], map.getZoom());
    });
    return null;
  }*/
  const Centerer = ({ center }) => {
    const map = useMap();
    useEffect(() => {
      map.setView(center);
    }, [center, map]);

    return null;
  };
  return (
    <>
      <div
        style={{
          left: "10px",
          position: "fixed",
          top: "90px",
          bottom: 0,
          height: "20px",
          color: "#C4DFE6",
          zIndex: 99,
          backgroundColor: "white",
          borderRadius: 90,
          opacity: 0.7,
        }}
        height="20px"
      >
        <div style={divstyle}>
          <FacebookShareButton url={shareUrl} className="Demo__some-network__share-button">
            <FacebookIcon size={32} round />
          </FacebookShareButton>
        </div>
        <div style={divstyle}>
          <FacebookMessengerShareButton
            url={shareUrl}
            appId="521270401588372"
            className="Demo__some-network__share-button"
          >
            <FacebookMessengerIcon size={32} round />
          </FacebookMessengerShareButton>
        </div>
        <div style={divstyle}>
          <TwitterShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <XIcon size={32} round />
          </TwitterShareButton>
        </div>
        <div style={divstyle}>
          <TelegramShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <TelegramIcon size={32} round />
          </TelegramShareButton>
        </div>
        <div style={divstyle}>
          <WhatsappShareButton
            url={shareUrl}
            title={title}
            separator=":: "
            className="Demo__some-network__share-button"
          >
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
        </div>
        <div style={divstyle}>
          <LinkedinShareButton url={shareUrl} className="Demo__some-network__share-button">
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
        </div>
        <div style={divstyle}>
          <EmailShareButton
            url={shareUrl}
            subject={title}
            body="body"
            className="Demo__some-network__share-button"
          >
            <EmailIcon size={32} round />
          </EmailShareButton>
        </div>
        <div style={divstyle}>
          <InstapaperShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <InstapaperIcon size={32} round />
          </InstapaperShareButton>
        </div>
        <div style={divstyle}>
          <ThreadsShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <ThreadsIcon size={32} round />
          </ThreadsShareButton>
        </div>
      </div>
      <h3>{t("map.header")}</h3>
      <p>{t("map.text")}</p>
      <div style={{ zIndex: 0 }}>
        <MapContainer
          center={[x, y]}
          zoom={zoom}
          style={{ zIndex: 0, height: "80vh", width: "100%" }}
        >
          <TileLayer
            style={{ zIndex: 0, height: "80vh", width: "100%" }}
            attribution="&copy; OpenStreetMap"
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <MapClickHandler onMapClick={handleMapClick} />
          <Centerer center={[x, y]} />
          {markers.map((marker, idx) => (
            <Marker key={idx} position={[marker.lat, marker.lng]}>
              <Popup>{marker.mapitem}</Popup>
            </Marker>
          ))}
          {smapitems.map((marker, idx) => (
            <Marker key={idx} position={[marker.x, marker.y]}>
              <Popup>{marker.maptext}</Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>
      <Typography variant="h3" gutterBottom>
        {t("strategy.sharemapitem")}
      </Typography>
      <MKTypography variant="h4" gutterBottom>
        {t("map.yourmarkers")}
      </MKTypography>
      {markers.length === 0 && <MKTypography>{t("strategy.noideas")}</MKTypography>}
      {markers.map((item, index) => (
        <Card key={index} style={{ marginBottom: "0.5rem" }}>
          <CardContent
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <MKTypography>{item.mapitem}</MKTypography>
            <Button
              variant="contained"
              style={{ color: "white" }}
              onClick={() => handleRemove(item.mapitem)}
            >
              {t("map.delete")}
            </Button>
          </CardContent>
        </Card>
      ))}
      <br />
      <br />
      <div style={{ width: "100%", marginLeft: "30%" }}>
        <ReCAPTCHA sitekey="6Lf6wLIaAAAAAORH1jwBkpv1NzwvaBYa9mpn39GP" onChange={onChange} />
      </div>
      <br />
      <Button
        variant="contained"
        style={{ color: "white" }}
        onClick={handleSubmit}
        disabled={!verified}
        executing={executing}
        submitted={submitted}
      >
        {t("strategy.savemapitem")}
      </Button>
      <br />
      <br />
      <MKTypography variant="h4" gutterBottom>
        {t("strategy.mapitemwall")}
      </MKTypography>
      {smapitems.length === 0 && <MKTypography>{t("strategy.noideas")}</MKTypography>}
      {smapitems.map((item, index) => (
        <Card key={index} style={{ marginBottom: "0.5rem" }}>
          <CardContent
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <MKTypography>{item.maptext}</MKTypography>
            <Button
              variant="contained"
              style={{ color: "white" }}
              onClick={() => handleVote(item.id)}
            >
              👍 {voteCount(item.id)}
            </Button>
          </CardContent>
        </Card>
      ))}
    </>
  );
};

export default Kartta;
